import { useRouter } from 'next/router'
import { useCallback, useRef, type FormEvent, type RefObject } from 'react'

import { useSelectButtonEvent, useSelectFieldEvent } from '@/core/analytics/hooks'
import { CookieStorage } from '@/core/utils/cookies'

import { Disclaimer } from '../Disclaimer'
import { DISCLAIMER_TEXTS } from '../Disclaimer/constants'

import { Form, FormFooter, FormInput, FormSubmitButton, FormWrapper } from './styles'

export const FreeDocumentConsultingForms = () => {
  const { push } = useRouter()
  const cpfInputRef = useRef<HTMLInputElement | null>(null)
  const cnpjInputRef = useRef<HTMLInputElement | null>(null)
  const selectFieldEvent = useSelectFieldEvent({ itemId: 'premium_web_campo_meio_09' })
  const selectButtonEvent = useSelectButtonEvent({ itemId: 'premium_web_botao_meio_10' })

  const consultDocument = useCallback(
    (document: string) => {
      CookieStorage.set('S_CAMPAIGN_USER', document)
      push('/voceconsulta/dados-checkout/?coupon=VCPE_BLCK2022')
    },
    [push],
  )

  const handleSubmit = useCallback(
    (
      event: FormEvent<HTMLFormElement>,
      documentInputRef: RefObject<HTMLInputElement>,
      selectContentEvent: typeof cpfEvents | typeof cnpjEvents,
    ) => {
      event.preventDefault()
      const document = documentInputRef.current?.value
      if (!document) return
      selectContentEvent()
      consultDocument(document)
    },
    [consultDocument],
  )

  const cpfEvents = useCallback(() => {
    selectFieldEvent({ label: 'cpf-a-ser-consultado' })
    selectButtonEvent({ label: 'consultar-cpf' })
  }, [selectFieldEvent, selectButtonEvent])

  const handleSubmitWithCpf = useCallback(
    (event: FormEvent<HTMLFormElement>) => handleSubmit(event, cpfInputRef, cpfEvents),
    [handleSubmit, cpfEvents],
  )

  const cnpjEvents = useCallback(() => {
    selectFieldEvent({ label: 'cnpj-empresa' })
    selectButtonEvent({ label: 'consultar-cnpj' })
  }, [selectFieldEvent, selectButtonEvent])

  const handleSubmitWithCnpj = useCallback(
    (event: FormEvent<HTMLFormElement>) => handleSubmit(event, cnpjInputRef, cnpjEvents),
    [handleSubmit, cnpjEvents],
  )

  return (
    <div className="media-with-forms__inputs">
      <FormWrapper>
        <Form onSubmit={handleSubmitWithCnpj}>
          <FormInput ref={cnpjInputRef} id="cnpj" name="cnpj" placeholder="CNPJ, somente números" />
          <FormSubmitButton type="submit" aria-label="Consultar CNPJ inserido">
            Consultar
          </FormSubmitButton>
        </Form>
        <Form onSubmit={handleSubmitWithCpf}>
          <FormInput ref={cpfInputRef} id="cpf" name="cpf" placeholder="CPF, somente números" />
          <FormSubmitButton type="submit" aria-label="Consultar CPF inserido">
            Consultar
          </FormSubmitButton>
        </Form>
      </FormWrapper>
      <FormFooter>
        <Disclaimer
          id="dc-footer-disclaimer"
          text={DISCLAIMER_TEXTS.documentConsulting.text}
          accessibleText={DISCLAIMER_TEXTS.documentConsulting.accessibleText}
          light="solid"
          className="document-consulting__footer__disclaimer"
        />
      </FormFooter>
    </div>
  )
}
